var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 60,
    viewBox: "0 0 49 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.3111C0 25.721 3.79729 22 8.48148 22H40.5185C45.2027 22 49 25.721 49 30.3111V51.6889C49 56.279 45.2027 60 40.5185 60H8.48147C3.79728 60 0 56.279 0 51.6889V30.3111ZM8.48148 24.0778C4.96834 24.0778 2.12037 26.8686 2.12037 30.3111V51.6889C2.12037 55.1314 4.96833 57.9222 8.48147 57.9222H40.5185C44.0317 57.9222 46.8796 55.1314 46.8796 51.6889V30.3111C46.8796 26.8686 44.0317 24.0778 40.5185 24.0778H8.48148Z",
    fill: "#F59D0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 34.1118C22.2413 34.1118 20.4102 36.0117 20.4102 38.3553C20.4102 39.9603 21.2685 41.3587 22.5397 42.0808L23.0687 42.3812V47.4032C23.0687 48.2234 23.7095 48.8882 24.4999 48.8882C25.2903 48.8882 25.9311 48.2234 25.9311 47.4032V42.3896L26.548 42.0295C27.771 41.2936 28.5898 39.923 28.5898 38.3553C28.5898 36.0117 26.7587 34.1118 24.5 34.1118ZM18.375 38.3553C18.375 34.8454 21.1173 32 24.5 32C27.8827 32 30.625 34.8454 30.625 38.3553C30.625 40.5315 29.5704 42.4511 27.9663 43.5955V47.4032C27.9663 49.3897 26.4144 51 24.4999 51C22.5854 51 21.0335 49.3897 21.0335 47.4032V43.5954C19.4294 42.4508 18.375 40.5314 18.375 38.3553Z",
    fill: "#F59D0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2.0493C18.8899 2.0493 14.342 6.50438 14.342 12V22.9753C14.342 23.5412 13.8737 24 13.296 24C12.7183 24 12.25 23.5412 12.25 22.9753V12C12.25 5.37258 17.7345 0 24.5 0C31.2655 0 36.75 5.37258 36.75 12V24H34.658V12C34.658 6.50438 30.1101 2.0493 24.5 2.0493Z",
    fill: "#F59D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.971dbe3118450d7bd8eaea853c938d11.svg";
export { ForwardRef as ReactComponent };